import { render, staticRenderFns } from "./FormationParameter.vue?vue&type=template&id=61d8ebb2"
import script from "./FormationParameter.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormationParameter.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports